export const getIsFetching = state => state.createUser.isFetching;
export const getMessage = state => state.createUser.errorMessage;
export const getSessionRol = state => state.createUser.errorRol;